<template>
  <span>
    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 7"
      :src="require('@/assets/img/mapa/IND/IND-B-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 14"
      :src="require('@/assets/img/mapa/IND/IND-B-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 21"
      :src="require('@/assets/img/mapa/IND/IND-B-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 28"
      :src="require('@/assets/img/mapa/IND/IND-B-2-IV.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 35"
      :src="require('@/assets/img/mapa/IND/IND-B-2-V.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 42"
      :src="require('@/assets/img/mapa/IND/IND-i-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 49"
      :src="require('@/assets/img/mapa/IND/IND-i-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 56"
      :src="require('@/assets/img/mapa/IND/IND-i-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 63"
      :src="require('@/assets/img/mapa/IND/IND-i-1-IV.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 70"
      :src="require('@/assets/img/mapa/IND/IND-i-1-V.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 77"
      :src="require('@/assets/img/mapa/IND/IND-i-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 84"
      :src="require('@/assets/img/mapa/IND/IND-i-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 91"
      :src="require('@/assets/img/mapa/IND/IND-i-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 98"
      :src="require('@/assets/img/mapa/IND/IND-i-2-IV.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 98"
      :src="require('@/assets/img/mapa/IND/IND-i-2-V.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>
  </span>
</template>

<script>
export default {
  props: {
    perguntaObj: { type: Object, required: true }
  }
}
</script>
